export default __webpack_public_path__ + "static/roadmap_0-495fe8a07034aa1f69949d25b35b3352.png";